export const auditStatuses = {
  10: '申请',
  20: '撤销',
  30: '驳回',
  100: '通过'
};



// WEBPACK FOOTER //
// ./src/config/auditStatuses.js